/* =========================================================
   TDM // STREET PRESS — interactions
   The cursor-following "REAL TEA ★" sticker (velocity-rotated lerp).
   Marquees, wobbles and reels are pure CSS. Cart + product links are
   real Shopify routes, so no client-side cart logic is needed.
   ========================================================= */
(function () {
  "use strict";

  function init() {
    var el = document.querySelector(".cursor-sticker");
    if (!el) return;
    // Skip on touch / coarse pointers — there is no cursor to chase.
    if (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) {
      el.style.display = "none";
      return;
    }

    var target = { x: -100, y: -100, rot: 0 };
    var pos = { x: -100, y: -100, rot: 0 };
    var lastX = -100;

    window.addEventListener("mousemove", function (e) {
      var dx = e.clientX - lastX;
      target.x = e.clientX;
      target.y = e.clientY;
      target.rot = Math.max(-25, Math.min(25, dx * 1.4));
      lastX = e.clientX;
    });

    (function tick() {
      pos.x += (target.x - pos.x) * 0.12;
      pos.y += (target.y - pos.y) * 0.12;
      pos.rot += (target.rot - pos.rot) * 0.18;
      el.style.transform =
        "translate(" + pos.x + "px, " + pos.y + "px) translate(-50%, -50%) rotate(" + pos.rot + "deg)";
      requestAnimationFrame(tick);
    })();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
